<template>
  <overview-table
    title="Quadro Resumo - Acessos"
    :headers="headers"
    :items="items"
  />
</template>

<script lang="ts" setup>
import Overview from '@/types/Overview'
import OverviewTable, { Header } from './partials/OverviewTable.vue'
import { computed } from 'vue'
import { currency } from '@/helpers/formatters/currency'

const { overview } = defineProps<{ overview: Overview }>()

// --- Items ---
const items = computed(() => {
  const paid = overview.summary.filter(item => parseInt(item.price) !== 0).reduce((prev, curr) => prev + curr.read, 0)
  const nonPaid = overview.summary.filter(item => parseInt(item.price) === 0).reduce((prev, curr) => prev + curr.read, 0)
  const signatures = overview.signatures.reduce((prev, curr) => prev + curr.quantity, 0)
  const revenue = overview.summary.filter(item => parseInt(item.price) !== 0).reduce((prev, curr) => {
    return prev + (curr.read * parseFloat(curr.price)) - parseFloat(curr.read_discounts)
  }, 0)

  return [
    { title: 'Público Pagante', value: paid },
    { title: 'Público Não Pagante', value: nonPaid },
    { title: 'Público Sócio-Torcedor', value: signatures },
    { title: 'Público Total', value: paid + nonPaid + signatures },
    { title: 'Renda Total', value: currency(revenue) },
  ]
})

// --- Header ---
const headers: Header[] = [
  { key: 'title' as const, value: 'title', title: 'Descrição', sortable: false },
  { key: 'value' as const, value: 'value', title: 'Valor', sortable: false },
]
</script>
